import { Linkedin, Mail } from "lucide-react";
import { siteConfig } from "@/config/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-24 md:pt-32 pb-10 overflow-hidden border-t border-white/10 bg-[#05070c]"
    >
      <div className="vs-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-14 pb-16">
          <div className="lg:col-span-5">
            <img src={siteConfig.logo} alt="VERYSIGHT" className="h-12 w-auto" style={{ mixBlendMode: "screen" }} />
            <p className="mt-6 max-w-md text-white/60 font-body leading-relaxed">
              {siteConfig.tagline}
            </p>
            <p className="mt-4 text-[13px] text-white/40 font-body leading-relaxed max-w-md">
              Independent Virtual CFO and Financial Intelligence advisory for owner-run
              businesses across UAE, India, Saudi Arabia and the Middle East.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 font-body">
              Quick Links
            </div>
            <ul className="mt-5 space-y-3">
              {siteConfig.nav.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    className="text-white/70 hover:text-[#d4af37] font-body text-[15px] transition-colors"
                    data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 font-body">
              Contact
            </div>
            <ul className="mt-5 space-y-3 text-[15px] font-body">
              <li>
                <a
                  href={`mailto:${siteConfig.contact.email}`}
                  className="text-white/75 hover:text-[#d4af37] transition-colors"
                  data-testid="footer-email"
                >
                  {siteConfig.contact.email}
                </a>
              </li>
              <li className="text-white/60">{siteConfig.contact.hqLabel}</li>
            </ul>

            <div className="mt-8 flex items-center gap-3">
              <a
                data-testid="footer-linkedin"
                href={siteConfig.social.linkedin}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="h-10 w-10 rounded-sm border border-white/15 flex items-center justify-center text-white/60 hover:border-[#d4af37] hover:text-[#d4af37] transition-colors"
              >
                <Linkedin size={16} />
              </a>
              <a
                data-testid="footer-email-icon"
                href={`mailto:${siteConfig.contact.email}`}
                aria-label="Email"
                className="h-10 w-10 rounded-sm border border-white/15 flex items-center justify-center text-white/60 hover:border-[#d4af37] hover:text-[#d4af37] transition-colors"
              >
                <Mail size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="pt-16 border-t border-white/10">
          <div
            aria-hidden
            className="font-serif-display text-white/[0.05] tracking-tighter leading-none select-none whitespace-nowrap overflow-hidden"
            style={{ fontSize: "clamp(90px, 18vw, 260px)" }}
          >
            VerySight
          </div>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-between gap-4 text-xs text-white/40 font-body">
          <div>© {year} VerySight. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#" data-testid="footer-privacy" className="hover:text-[#d4af37] transition-colors">
              Privacy Policy
            </a>
            <a href="#" data-testid="footer-terms" className="hover:text-[#d4af37] transition-colors">
              Terms
            </a>
            <span className="text-white/30">·</span>
            <a
              href={`https://${siteConfig.contact.website}`}
              className="hover:text-[#d4af37] transition-colors"
            >
              {siteConfig.contact.website}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
